import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouteEntity } from '@core/router/route.entity';
import { RouterLink } from '@angular/router';
import { LoginResponse } from '@api/models/UserService/Contract/login-response';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * User card context menu
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-user-card-menu',
    templateUrl: './user-card-menu.component.html',
    styleUrls: ['./user-card-menu.component.scss'],
    imports: [
        RouterLink,
        TranslatePipe,
    ],
})
export class UserCardMenuComponent {
    /**
     * System user data object
     */
    @Input() public user: LoginResponse;

    public readonly routeEntity: typeof RouteEntity = RouteEntity;
}
